import { useMemo } from 'react';

import { useEpisodeDetailsData } from '@insights_module/hooks/useEpisodeDetailsData';
import { GarmFilter } from '@insights_module/types/BrandSafety';

export const useEpisodeWithDetails = () => {
  const { selectedEpisodeDetails, isLoading } = useEpisodeDetailsData();

  const episodeWithDetails = useMemo(() => {
    return {
      ...selectedEpisodeDetails,
      garmFilters: Object.entries(selectedEpisodeDetails?.brand_safety_garm || {}).map(
        ([key, val]) => ({ category: key, risk: val }) as GarmFilter
      ),
      details: {
        id: selectedEpisodeDetails?.id,
        title: selectedEpisodeDetails?.title,
        duration: selectedEpisodeDetails?.duration,
        coverImage: selectedEpisodeDetails?.coverImage,
        showName: selectedEpisodeDetails?.showTile,
      },
      publishDate: new Date(selectedEpisodeDetails?.published_date || ''),
      processDate: new Date(selectedEpisodeDetails?.created_at || ''),
      garm: { results: selectedEpisodeDetails?.brand_safety_garm || {}, isLoading },
    };
  }, [selectedEpisodeDetails, isLoading]);

  return {
    episodeWithDetails,
    isLoading,
  };
};
